import { Injectable } from "@angular/core";
import { CORE_ROUTE } from "@obg/ngx.core";

@Injectable({
	providedIn: "root",
})
export class MenuConfigService {
	getUrlsWithoutExactMatch(): string[] {
		return [
			"sportsbook.live",
			CORE_ROUTE.marketingSettings.root,
			CORE_ROUTE.loyalty.root,
			CORE_ROUTE.oms.messages,
			CORE_ROUTE.transactionHistory.all,
			"game-rules",
		];
	}
}
